var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#5AB43A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8141 5.80766C11.5666 5.5598 11.1647 5.55996 10.9168 5.80766L6.8783 9.84632L5.08335 8.05139C4.8355 7.80354 4.43374 7.80354 4.18589 8.05139C3.93804 8.29924 3.93804 8.70101 4.18589 8.94886L6.42947 11.1924C6.55332 11.3163 6.71571 11.3784 6.87812 11.3784C7.04053 11.3784 7.20309 11.3164 7.32693 11.1924L11.8141 6.7051C12.062 6.45742 12.062 6.05549 11.8141 5.80766Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/acceptIcon.4957fc4c8da7c32efcd639e3a88284e4.svg";
export { ForwardRef as ReactComponent };